import React, { useState, createContext } from "react";
import moment from "moment";

const timeNow = moment().format("HH:mm");

export const GlobalStateContext = createContext({
  isLogin: false,
  setIsLogin: () => {},
  isChatBoxOpen: false,
  setIsChatBoxOpen: () => {},
  chatboxResponse: [],
  setChatboxResponse: () => {},
  productName: "",
  setProductName: () => {},
  recipeId: null,
  setRecipeId: () => {},
  isMobileView: null,
  setIsMobileView: () => {},
  loginRole: 0,
  setLoginRole: () => {},
  topicId: "",
  setTopicId: () => {},
  customerChatUnreadCount: 0,
  setCustomerChatUnreadCount: () => {},
});

const GlobalStateProvider = ({ children }) => {
  const [isLogin, setIsLogin] = useState(false);
  const [recipeId, setRecipeId] = useState(null);
  const [isChatBoxOpen, setIsChatBoxOpen] = useState(false);
  const [chatboxResponse, setChatboxResponse] = useState([]);
  const [productName, setProductName] = useState("");
  const [isMobileView, setIsMobileView] = useState(false);
  const [loginRole, setLoginRole] = useState(0);
  const [topicId, setTopicId] = useState("");
  const [customerChatUnreadCount, setCustomerChatUnreadCount] = useState(0);

  return (
    <GlobalStateContext.Provider
      value={{
        isLogin,
        setIsLogin,
        isChatBoxOpen,
        setIsChatBoxOpen,
        chatboxResponse,
        setChatboxResponse,
        productName,
        setProductName,
        recipeId,
        setRecipeId,
        isMobileView,
        setIsMobileView,
        loginRole,
        setLoginRole,
        topicId,
        setTopicId,
        customerChatUnreadCount,
        setCustomerChatUnreadCount,
      }}
    >
      {children}
    </GlobalStateContext.Provider>
  );
};

export default GlobalStateProvider;
